import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Routes } from 'constants/index';
import { RowSpace } from 'types';
import { Row, Col } from 'components';
import MainLogo from 'resources/images/logo.png'; // Default import for PNG
import LanguageSelectView from 'pages/common/actions/language-select/LanguageSelect';
import styles from './BasicHeader.module.scss';
import { PrimaryButton } from 'components';
import NavMenus from 'components/menus/navmenus/NavMenus';
import { MenuOutlined, CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

const BasicHeader: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  // Handle search submission
  const handleSearchSubmit = () => {
    if (searchQuery.trim()) {
      // Navigate to the search results page with the query as a parameter
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  // Handle pressing "Enter" key in the search input
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearchSubmit();
    }
  };

  return (
    <header className={styles.header}>
      <Row
        wrap={false}
        verticalSpace={RowSpace.None}
        horizontalSpace={RowSpace.None}
        justify='space-between'
        align='middle'
      >
        <Col flexible>
          <Link to={Routes.home}>
            <img src={MainLogo} alt='Logo' className={styles.logo} />
          </Link>
        </Col>

        {/* Search Field */}
        {/* <div className={styles.searchField}>
          <Input
            placeholder='Search...'
            prefix={<SearchOutlined />}
            allowClear
            className={styles.searchInput}
            value={searchQuery}
            onChange={handleSearchChange}
            onKeyDown={handleKeyPress}
          />
        </div> */}

        {/* Toggle Button for Mobile */}
        <div className={styles.menuToggle} onClick={toggleMenu}>
          {isMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
        </div>

        {/* Right Side Content */}
        <div className={`${styles.rightSide} ${isMenuOpen ? styles.open : ''}`}>
          <NavMenus />
          <div className={styles.buttonGroup}>
            <PrimaryButton
              className='customButton'
              onClick={() => (window.location.href = 'https://app.carbondigitalmarket.com/')}
            >
              Trade here
            </PrimaryButton>
            <LanguageSelectView />
          </div>
        </div>
      </Row>
    </header>
  );
};

export default BasicHeader;
